<template>
  <router-view name="member" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Member",
};
</script>
